import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'CONTENTS';

const fields = [  
  'IMPORTANT_ANNOUNCEMENT',
  'ABOUT',
  'PRE_ABOUT',
  'PRIVACY_POLICY',
  'TERMS_AND_CONDITION',
  'DECLARATION',
  'CEDULA_DECLARATION',
  'CIVIL_REGISTRY_DECLARATION',
  'PAY_NOW_REMARKS',
  'BPLS_PAY_NOW_REMARKS'
];

function Contents({
  getList,
  createRichTextEditor,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  draftToHtml,
  htmlToDraft,
  convertToRaw
}) {
  const richTextEditorProps = {
    required: true,
    wrapperClassName: 'border',
    editorStyle: { maxHeight: 260, overflowY: 'auto', padding: '0 8px' },
  };

  const contentSections = [
    { key: 'BPLS_PAY_NOW_REMARKS', label: 'BPLS PAY NOW REMARKS' },
    { key: 'PAY_NOW_REMARKS', label: 'PAY_NOW_REMARKS' },
    { key: 'CEDULA_DECLARATION', label: 'CEDULA DECLARATION' },
    { key: 'CIVIL_REGISTRY_DECLARATION', label: 'CIVIL REGISTRY DECLARATION' },
    { key: 'DECLARATION', label: 'BPLS DECLARATION' },
    { key: 'PRIVACY_POLICY', label: 'PRIVACY_POLICY' },
    { key: 'TERMS_AND_CONDITION', label: 'TERMS_AND_CONDITION' },
  ];

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    if(item){
      const retrievedData = JSON.parse(_.get(item, 'attributes.body') || '{}')
      const formattedHtmlToDraft = (data) => {
        const rawHtml = typeof data === 'string' ? data : '';
        return htmlToDraft(rawHtml);
      };

      setFormData({
        IMPORTANT_ANNOUNCEMENT: formattedHtmlToDraft(_.get(retrievedData, 'IMPORTANT_ANNOUNCEMENT')),
        PRE_ABOUT: formattedHtmlToDraft(_.get(retrievedData, 'PRE_ABOUT', '')),
        ABOUT: formattedHtmlToDraft(_.get(retrievedData, 'ABOUT', '')),
        PRIVACY_POLICY: formattedHtmlToDraft(_.get(retrievedData, 'PRIVACY_POLICY', '')),
        TERMS_AND_CONDITION: formattedHtmlToDraft(_.get(retrievedData, 'TERMS_AND_CONDITION', '')),
        DECLARATION: formattedHtmlToDraft(_.get(retrievedData, 'DECLARATION')),
        CEDULA_DECLARATION: formattedHtmlToDraft(_.get(retrievedData, 'CEDULA_DECLARATION')),
        CIVIL_REGISTRY_DECLARATION: formattedHtmlToDraft(_.get(retrievedData, 'CIVIL_REGISTRY_DECLARATION', '')),
        PAY_NOW_REMARKS: formattedHtmlToDraft(_.get(retrievedData, 'PAY_NOW_REMARKS', '')),
        BPLS_PAY_NOW_REMARKS: formattedHtmlToDraft(_.get(retrievedData, 'BPLS_PAY_NOW_REMARKS', '')),
        id: _.get(item, 'id'),
      });
    }
    
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newPayload = {
      ...formData,
      IMPORTANT_ANNOUNCEMENT: draftToHtml(convertToRaw(_.get(formData, 'IMPORTANT_ANNOUNCEMENT').getCurrentContent())),
      PRE_ABOUT: draftToHtml(convertToRaw(_.get(formData, 'PRE_ABOUT').getCurrentContent())),
      ABOUT: draftToHtml(convertToRaw(_.get(formData, 'ABOUT').getCurrentContent())),
      PRIVACY_POLICY: draftToHtml(convertToRaw(_.get(formData, 'PRIVACY_POLICY').getCurrentContent())),
      TERMS_AND_CONDITION: draftToHtml(convertToRaw(_.get(formData, 'TERMS_AND_CONDITION').getCurrentContent())),
      DECLARATION: draftToHtml(convertToRaw(_.get(formData, 'DECLARATION').getCurrentContent())),
      CEDULA_DECLARATION: draftToHtml(convertToRaw(_.get(formData, 'CEDULA_DECLARATION').getCurrentContent())),
      CIVIL_REGISTRY_DECLARATION: draftToHtml(convertToRaw(_.get(formData, 'CIVIL_REGISTRY_DECLARATION').getCurrentContent())),
      PAY_NOW_REMARKS: draftToHtml(convertToRaw(_.get(formData, 'PAY_NOW_REMARKS').getCurrentContent())),
      BPLS_PAY_NOW_REMARKS: draftToHtml(convertToRaw(_.get(formData, 'BPLS_PAY_NOW_REMARKS').getCurrentContent()))
    }

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        body: JSON.stringify(_.pick(newPayload, [...fields])),
      });
    }

    return create({
      body: JSON.stringify(_.pick(newPayload, [...fields])),
    });
  };
  
  return (
    <div className="card border shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden({ key: 'id' }, { placeholder: '' })}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Content Management</h5>
              <p className="mb-0 text-muted">
                Manage content texts, declarations, and remarks.
              </p>
            </div>
          </div>
          <div className="row">
            {contentSections.map(section => (
              <div key={section.key} className="col-12 mb-3">
                <div className="border rounded bg-white shadow-sm p-3 form-group group-cms-color mb-0">
                  {createRichTextEditor(
                    { key: section.key, label: section.label },
                    richTextEditorProps
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Contents.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Contents);
